var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "widM NCAcmi_cont01_wrap" }, [
        _vm.mainResponses
          ? _c(
              "div",
              { staticClass: "clearfix" },
              [
                _vm._l(_vm.mainResponses, function(mainAttendant, idx) {
                  return [
                    _c("SurveyParticipant", {
                      key: "mainAttendant" + idx,
                      attrs: { seq: idx, participant: mainAttendant }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      key: "mainAttendant_span" + idx,
                      staticClass: "disIb moOnly",
                      staticStyle: { padding: "2.5px" }
                    }),
                    _vm._v(" "),
                    idx < _vm.mainResponses.length - 1
                      ? _c("hr", {
                          key: "mainAttendant_hr" + idx,
                          staticClass: "moOnly",
                          staticStyle: {
                            "border-top": "1px solid #ddd",
                            background: "#f4f4f4",
                            padding: "5px 0"
                          }
                        })
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.existMemberAttendant
        ? [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "widM" }, [
              _c("div", { staticClass: "NCAcmi_family padTM" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "floR NCAcmi_family_attend" }, [
                  _c("div", { staticClass: "amway-theme txtR" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "action NCAcmi_radioBtn radio-wrapper NCAcmi_family_radio NCAcmi_familyN"
                      },
                      [
                        _c(
                          "label",
                          { staticClass: "amw-radio-wrap radio-label focus" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.familyAttendanceYn,
                                  expression: "familyAttendanceYn"
                                }
                              ],
                              staticClass: "amw-global-radio",
                              attrs: {
                                type: "radio",
                                name: "radio-family",
                                value: "Y",
                                disabled: !_vm.infoAvailable
                              },
                              domProps: {
                                checked: _vm._q(_vm.familyAttendanceYn, "Y")
                              },
                              on: {
                                change: function($event) {
                                  _vm.familyAttendanceYn = "Y"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "amw-radio-overlay" }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "amw-label-radio-text" },
                              [_vm._v("참여")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "amw-radio-wrap radio-label focus" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.familyAttendanceYn,
                                  expression: "familyAttendanceYn"
                                }
                              ],
                              staticClass: "amw-global-radio",
                              attrs: {
                                type: "radio",
                                name: "radio-family",
                                value: "N",
                                disabled: !_vm.infoAvailable
                              },
                              domProps: {
                                checked: _vm._q(_vm.familyAttendanceYn, "N")
                              },
                              on: {
                                change: function($event) {
                                  _vm.familyAttendanceYn = "N"
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "amw-radio-overlay" }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "amw-label-radio-text" },
                              [_vm._v("불참")]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _vm.familyAttendanceYn === "Y"
              ? [
                  _vm._l(_vm.familyResponses, function(family, idx) {
                    return [
                      _c("hr", {
                        key: "familyResponses_hr" + idx,
                        staticStyle: {
                          "border-top": "1px solid #ddd",
                          background: "#f4f4f4",
                          padding: "5px 0"
                        }
                      }),
                      _vm._v(" "),
                      _c("SurveyParticipantFamily", {
                        key: "familyResponses" + idx,
                        attrs: { idx: idx, participant: family }
                      })
                    ]
                  }),
                  _vm._v(" "),
                  _vm.infoAvailable && !_vm.isExceededFamilyCountLimit
                    ? [
                        _c("hr", {
                          staticClass: "padBS",
                          staticStyle: { "border-color": "#ddd" }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "widM NCAcim_familyN_plus",
                            class: { NCAcmi_familyN_Btn: !_vm.canAddFamily },
                            style: {
                              cursor: _vm.canAddFamily ? "pointer" : "default"
                            },
                            on: { click: _vm.addNewFamily }
                          },
                          [_vm._m(5)]
                        )
                      ]
                    : _vm._e()
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: { background: "#f4f4f4", "border-top": "2px solid #ddd" }
      },
      [
        _c(
          "div",
          {
            staticClass: "widM fntH4 bold padTS padBS",
            staticStyle: { color: "#2c2c2c" }
          },
          [_vm._v("참가자 정보")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM padTM" }, [
      _c(
        "ul",
        {
          staticClass: "osResNoticeList fntE colorGray",
          staticStyle: { "padding-left": ".5em", "text-indent": "-.5em" }
        },
        [
          _c("li", [
            _vm._v("- "),
            _c("em", { staticStyle: { color: "#e11e45" } }, [_vm._v("*")]),
            _vm._v(" 표시는 필수 입력사항입니다.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "- 첨부파일은 JPG, PNG, PDF 형식으로 최대 10MB까지 등록하실 수 있습니다."
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "marTML",
        staticStyle: { background: "#f4f4f4", "border-top": "2px solid #ddd" }
      },
      [
        _c(
          "div",
          {
            staticClass: "widM fntH4 bold padTS padBS",
            staticStyle: { color: "#2c2c2c" }
          },
          [_vm._v("동반가족 정보")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "floL fntP" }, [
      _vm._v("참여 여부 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM marBML" }, [
      _c(
        "div",
        { staticClass: "fntP bold padTM", staticStyle: { color: "#012f60" } },
        [_vm._v("동반 가족 범위(도표)")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padTM padBM marTS",
          staticStyle: { background: "#f5f5f5" }
        },
        [
          _c(
            "div",
            {
              staticClass: "osResTbScrollWrap widM",
              staticStyle: { border: "none", "box-shadow": "none" }
            },
            [
              _c("div", { staticClass: "osResTbScroll" }, [
                _c("p", { staticClass: "bold padLM fntH6" }, [
                  _c("span", { staticStyle: { color: "#002f5f" } }, [
                    _vm._v("기존 /")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "#d0824d" } }, [
                    _vm._v("추가")
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "padM",
                  attrs: {
                    src: require("../images/cont01_family_chart.png"),
                    alt:
                      "새로운 동반 가족 범위(도표) - 기존 2촌 이내 가족에서 3촌 이내 가족으로 동반 가족 범위가 확대됩니다."
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "marTSM", staticStyle: { color: "#002f5f" } },
                  [
                    _vm._v(
                      "※ 만 12세 이하의 어린이는 현지에서 진행되는 모든 프로그램에 보호자를 동반하여야 참여할 수 있음."
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "padTSM padBSM",
        staticStyle: {
          display: "flex",
          "justify-content": "center",
          "align-items": "center"
        }
      },
      [
        _c("div", { staticClass: "padRM" }, [
          _c("img", {
            staticStyle: { "max-width": "30px" },
            attrs: {
              src: require("../images/NCAcmi_plus.png"),
              alt: "플러스 아이콘"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "txtL",
            staticStyle: { color: "#fff", "line-height": "2" }
          },
          [_c("p", { staticClass: "fntP regular" }, [_vm._v("동반가족 추가")])]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19e0381f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e0381f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyParticipantInfo.vue
// module id = null
// module chunks = 